import * as React from 'react';

interface IDefaultLayoutProps {
    children: any;
}

class DefaultLayout extends React.PureComponent<IDefaultLayoutProps, any> {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                {this.props.children}
            </div>
        );
    }
}

export default DefaultLayout;